<template>
  <div class="brand-apply">
    <div class="step">
      <el-steps :active="0" class="step-container" align-center>
        <el-step title="申请"></el-step>
        <el-step title="审批"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div class="content">
      <el-form
        :model="brandForm"
        :rules="brandRules"
        label-width="260px"
        label-position="right"
        class="container-body"
      >
        <el-form-item label="品牌中文名称：" prop="brandName">
          <span>{{ brandForm.brandName }}</span>
        </el-form-item>
        <el-form-item label="品牌英文名称：" prop="applyDesc">
          <span>{{ brandForm.brandNameEN }}</span>
        </el-form-item>
        <el-form-item label="品牌图片：" prop="applyDesc">
          <multi-image-upload
            :url="imageUrls"
            :hasDel="false"
            :imageSize="4"
            @handleimgInfo="handleBrandImage"
            :hasUpload="false"
          />
        </el-form-item>
        <el-form-item label="申请材料：" prop="applyDesc">
          <file-upload
            :uploadUrl="uploadUrl"
            :url="fileList"
            accept=".pdf,.jpg,.jpeg,.png"
            :limit="10"
            @getFileInfo="getFileInfo"
            :uploadImage="true"
            :fileSize="20"
            :ifUploadBtn="false"
          >
            <template #message>
              <p>上传品牌授权书或品牌证明材料</p>
              <p>支持PDF、JPG、JPEG、PNG格式，文件大小不超过10M。</p>
            </template>
          </file-upload>
        </el-form-item>
        <el-form-item
          class="agreement-label"
          label="选择您要绑定的产品目录："
          prop="mdmCategoryName"
        >
          <div class="container-purchase">
            <div style="display: flex;">
              <div class="left">
                <div class="search">
                  <div>可售产品目录：</div>
                  <div class="scrollbar">
                    <el-scrollbar
                      ref="scrollbarCategory2"
                      @wheel.native.prevent="handleWheelCategory2"
                      style="height: 100%;"
                    >
                      <el-tree
                        class="tree"
                        :props="defaultProps"
                        :data="treeData"
                        node-key="categoryId"
                        ref="tree"
                      >
                        <template slot-scope="{ node }">
                          <el-tooltip
                            v-if="node.label.length > 15"
                            class="item"
                            effect="dark"
                            :content="node.label"
                            placement="right"
                          >
                            <div style="width:205px" class="ellipsis">{{ node.label }}</div>
                          </el-tooltip>
                          <span v-else> {{ node.label }}</span>
                        </template>
                      </el-tree>
                    </el-scrollbar>
                  </div>
                </div>
              </div>
              <div class="middle">
                <img
                  style="cursor: pointer"
                  src="../../../../../assets/img/agreement/right-arrow.png"
                />
              </div>
              <div class="right">
                <div>选中产品目录：</div>
                <div class="scrollbar">
                  <el-scrollbar
                    ref="scrollbarCategory3"
                    @wheel.native.prevent="handleWheelCategory3"
                    style="height: 100%;"
                  >
                    <ul>
                      <li
                        class="scrollbar-li"
                        :class="activeMdmInx == index ? 'scrollbar-active' : ''"
                        v-for="(item, index) in categoryList"
                        :key="index"
                        @click="handleMdmActive(index)"
                        @mouseover="handleMdmActive(index)"
                      >
                        <div style="display: flex;justify-content: space-between;">
                          <el-tooltip
                            v-if="item.categoryName.length > 15"
                            :content="item.categoryName"
                            placement="top"
                            effect="light"
                          >
                            <div style="width: 230px;margin-right: 20px" class="ellipsis">
                              {{ item.categoryName }}
                            </div>
                          </el-tooltip>
                          <div v-else style="width: 230px;margin-right: 20px" class="ellipsis">
                            {{ item.categoryName }}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </el-scrollbar>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            style="width: 70%;"
            maxlength="30"
            show-word-limit
            type="textarea"
            v-model="brandForm.remark"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="submit-btn">
      <el-button @click="handleGoBack">取消</el-button>

      <!-- <div>
        <el-button type="primary" @click="handleSave">保存</el-button>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </div> -->
    </div>
    <div class="hint">
      如果您在申请品牌的过程中遇到问题，请拔打电话010-85539100或发送邮件至wzwangyali@sinopec.com
    </div>
  </div>
</template>

<script>
import api from "../../../api/product";
import fileUpload from "../components/fileUpload.vue";
import multiImageUpload from "../components/multiImageUpload.vue";
export default {
  components: { fileUpload, multiImageUpload },
  props: {},
  data() {
    return {
      restaurants: [],
      state: "",
      timeout: null,

      activeMdmInx: "",
      searchTreeShow: false,
      mdmCategoryQuery: {
        mdmCategoryName: ""
      },
      brandForm: {
        active: 1,
        applyType: 1,
        brandName: "",
        applyDesc: "",
        deadline: "",
        remark: ""
      },
      treeData: [],
      mdmDataList: [],
      defaultProps: {
        label: "categoryName",
        children: "children"
      },
      // 文件回显列表
      fileList: [],
      uploadUrl: api.fileUploadForProductFile,
      brandRules: {
        brandName: [{ required: true, message: "请输入品牌中文名称", trigger: "blur" }]
      },
      // 图片
      imageUrls: [],
      categoryList: []
    };
  },
  computed: {},
  created() {
    this.getDetailInfo();
    this.getTreeData();
  },
  methods: {
    // 获取treeData
    async getTreeData() {
      const { getCategoryListByAgreement } = api;
      const res = await getCategoryListByAgreement();
      if (res.code === "200") {
        this.treeData = [...res.data];
      }
    },
    async getDetailInfo() {
      const { brandAuditId } = this.$route.query;
      const { queryBrandAuditDetail } = api;
      const result = await queryBrandAuditDetail({ brandAuditId });
      if (result.code === "200") {
        const data = result.data;
        this.brandForm = Object.assign({}, data);
        this.categoryList = data.categoryList.length ? data.categoryList : [];
        this.imageUrls = this.brandForm.brandImage ? [this.brandForm.brandImage] : [];
        const brandFileArr = this.brandForm.brandFile ? this.brandForm.brandFile.split(".") : "";
        this.fileList = this.brandForm.brandFile
          ? [
              {
                fileUrl: this.brandForm.brandFile,
                fileName: `申请材料.${brandFileArr[brandFileArr.length - 1]}`
              }
            ]
          : [];
        console.log(this.fileList, "文件名字");
      }

      console.log(result, "详情");
    },
    handleBrandImage(file) {
      console.log(file);
    },
    //----搜索
    getFileInfo(file) {
      console.log(file);
    },
    handleWheelCategory2(e) {
      let wrap = this.$refs.scrollbarCategory2.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleWheelCategory3(e) {
      let wrap = this.$refs.scrollbarCategory3.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleMdmActive(inx) {
      this.activeMdmInx = inx;
    },
    handleSave() {},
    handleSubmit() {},
    handleGoBack() {
      this.$router.push({ path: "/brandManage" });
    }
  }
};
</script>

<style scoped lang="scss">
.brand-apply {
  .content {
    margin-top: 20px;
    background: #fff;
    padding-bottom: 0;
    /* .brand-name {
      position: relative;
      span {
        position: absolute;
        left: 0;
        top: 26px;
        font-size: 12px;
        color: #f0250f;
      }
    } */
  }
  .container-body {
    width: 100%;
    margin-left: 20px;
    .el-input-width {
      width: 266px;
      height: 28px;
    }
    .container-purchase {
      background: #f8f8f8;
      width: 725px;
      height: 424px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      .left {
        width: 308px;
        height: 360px;
        background-color: #ffffff;
        padding: 10px 10px 10px;
        .search {
          width: 100%;
          .scrollbar {
            height: 242px;
            overflow: hidden;
          }
        }
      }
      .right {
        width: 298px;
        height: 360px;
        background-color: #ffffff;
        padding: 10px 10px 10px;
        .scrollbar {
          height: 316px;
          overflow: hidden;
          .scrollbar-li {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
          }
          .scrollbar-active {
            background: #f4f7ff;
          }
        }
      }
      .middle {
        width: 60px;
        height: 360px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 35px;
          width: 18px;
        }
      }
      .tip {
        font-size: 14px;
        color: #999999;
      }
    }
    .agreement-label {
      .el-form-item__label:before {
        content: "* ";
        color: red;
      }
    }
  }
  .submit-btn {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    ::v-deep .el-button {
      min-width: 80px;
      height: 30px;
      font-size: 14px;
      padding: 0 10px;
      /* line-height: 30px; */
      text-align: center;
      & + .el-button {
        margin-left: 20px;
      }
    }
  }
  .hint {
    margin-top: 20px;
    background: #e8efff;
    color: #333333;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 12px;
  }
  .step-container ::v-deep .el-step__head.is-process .el-step__line {
    border: 1px solid #2587ff;
    // left: 65%;
    background-color: transparent;
    margin-right: 45px !important;
    margin-left: 45px;
    top: 13px;
    // width: 150px;
  }
  .step-container ::v-deep .el-step__head.is-process .el-step__icon {
    width: 30px;
    height: 30px;
    color: #ffffff;
    border: 1px solid #2587ff;
    background: #2587ff;
  }
  .step-container ::v-deep .el-step__head.is-wait .el-step__line {
    border: 1px dashed #c5c5c5;
    // left: 65%;
    background-color: transparent;

    margin-right: 45px !important;
    margin-left: 45px;
    top: 13px;
    // width: 150px;
  }
  .step-container ::v-deep .el-step__head.is-wait .el-step__icon {
    width: 30px;
    height: 30px;
    color: #c5c5c5;
    border: 1px solid #c5c5c5;
  }
  .step-container ::v-deep .el-step__icon {
    width: 30px;
    height: 30px;
    border: 1px solid #d9d9d9;
    // background-color: transparent;
    background-color: #ededed;
  }
  .step-container.el-step__icon.is-text {
    border: 1px solid #d9d9d9;
  }
  .step-container.el-step__icon-inner {
    color: #c5c5c5;
    font-size: 14px;
    font-weight: 400;
  }
  .scrollbar ::v-deep .el-scrollbar__wrap {
    overflow: hidden;
    margin-right: 0 !important;
  }
  .scrollbar ::v-deep .el-scrollbar__bar.is-vertical {
    background: #f5f5f5;
    border-radius: 2px;
    width: 3px;
    opacity: 1;
    margin-right: -2px;
  }
  .scrollbar ::v-deep .el-scrollbar__bar.is-horizontal {
    background: #f5f5f5;
    border-radius: 2px;
    height: 3px;
    margin-bottom: -2px;
    &:hover {
      opacity: 0;
    }
  }
}
</style>
